
<section class="storyblok-blok-container">
  <ng-container *ngTemplateOutlet="!banner.filename ? noImageHeadline : imageHeadline"></ng-container>
</section>

<ng-template #noImageHeadline>
  <div
    class="no-image-headline-banner"
    appIsVisible
    (isVisible)="initializeHeadlineBanner()"
  >
    <h1 [lang]="market">{{ headline }}</h1>
  </div>
</ng-template>

<ng-template #imageHeadline>
  <div
    class="image-headline-banner"
    appIsVisible
    (isVisible)="initializeHeadlineBanner()"
  >
    <div class="image-headline-banner__info-section">
      <h1 [lang]="market">{{ headline }}</h1>
    </div>
    <div
      appSkewClipPath
      [title]="banner.title"
      [attr.aria-label]="banner.alt"
      class="image-headline-banner__banner-section"
      [style.background-image]="'url(' + (banner.filename + sbFormatParam) + ')'"
    ></div>
  </div>
</ng-template>
